import type { ReactNode } from "react";

import PublicTrackerDetailPage from "./PublicTrackerDetailPage";

type PublicTrackerDetailRouteProps = {
  authenticatedView: ReactNode;
  isSignedIn: boolean;
};

function PublicTrackerDetailRoute({
  authenticatedView,
  isSignedIn,
}: PublicTrackerDetailRouteProps) {
  if (isSignedIn) {
    return <>{authenticatedView}</>;
  }

  return <PublicTrackerDetailPage />;
}

export default PublicTrackerDetailRoute;
